import {
  Box,
  Button,
  Center,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import { CampanhaWhatsAppCompletedDataProps } from "components/campanha-whatsapp-components/utils";
import { CustomModal } from "components/custom-modal";
import { CloseIcon } from "components/vectors/close-icon";
import { MessageSquareIcon } from "components/vectors/message-square-icon";
import { SendIcon } from "components/vectors/send-icon";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { useState } from "react";
import { BiMessageSquareDetail } from "react-icons/bi";
import { messageTypeOptions } from "../modal-campanha-whatsapp/steps/steps";

export const eventName = "open-modal-dados-da-campanha-whats-app";

export function ModalDadosDaCampanhaWhatsApp() {
  const [fields, setFields] = useState<CampanhaWhatsAppCompletedDataProps>();
  const { isOpen, onClose } =
    useModalControls<CampanhaWhatsAppCompletedDataProps>(eventName, {
      onOpen: (params) => {
        if (!params) {
          throw new Error("Parâmetros obrigatórios para abrir o modal.");
        }
        setFields(params);
      },
      onClose: () => {
        setTimeout(() => setFields(undefined), 600);
      },
    });

  const modalFooter = (
    <>
      <Button variant="outline" onClick={onClose} leftIcon={<CloseIcon />}>
        Fechar
      </Button>
    </>
  );

  return (
    <CustomModal
      modalTitle={"Dados da Campanha"}
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      modalFooter={modalFooter}
      scroll="inside"
    >
      <Box
        bg="gray.50"
        border="1px solid"
        borderColor="gray.100"
        rounded="lg"
        p={6}
        gap={4}
      >
        <VStack align="stretch" spacing={4}>
          <HStack align="start" spacing={3}>
            <Center w="36px" h="36px" bg="blue.100" p={2} rounded="md">
              <MessageSquareIcon color="blue.600" />
            </Center>
            <Box>
              <Text fontSize="sm" fontWeight="medium" color="primary.400">
                Dados da Campanha
              </Text>
              <VStack align="start" mt={2} spacing={1}>
                <Text fontSize="sm" color="gray.600">
                  <Box as="span" fontWeight="medium">
                    Nome:
                  </Box>{" "}
                  {fields?.name || "Não definido"}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  <Box as="span" fontWeight="medium">
                    Arquivo CSV:
                  </Box>{" "}
                  {fields?.filenameContato || "Não selecionado"}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  <Box as="span" fontWeight="medium">
                    Coluna de Telefone:
                  </Box>{" "}
                  {fields?.fonesColunas?.join(", ") || "Não selecionada"}
                </Text>
              </VStack>
            </Box>
          </HStack>
          <HStack align="start" spacing={3}>
            <Center bg="green.100" w="36px" h="36px" p={2} rounded="md">
              <Icon
                as={BiMessageSquareDetail}
                color="green.600"
                w="100%"
                h="auto"
              />
            </Center>
            <Box>
              <Text fontSize="sm" fontWeight="medium" color="primary.400">
                Mensagem
              </Text>
              <VStack align="start" mt={2} spacing={1}>
                <Text fontSize="sm" color="gray.600">
                  <Box as="span" fontWeight="medium">
                    Tipo:
                  </Box>{" "}
                  {messageTypeOptions().find(
                    ({ value }) => value === fields?.type
                  )?.label || "Não definido"}
                </Text>
                {fields?.enabledMensagemSaudacao && (
                  <Text fontSize="sm" color="gray.600">
                    <Box as="span" fontWeight="medium">
                      Saudação:
                    </Box>{" "}
                    {fields?.mensagemSaudacao || "Padrão"}
                  </Text>
                )}
                {fields?.type === "TEXT" && (
                  <Text fontSize="sm" color="gray.600">
                    <Box as="span" fontWeight="medium">
                      Conteúdo:
                    </Box>{" "}
                    {fields?.mensagemNormal || "Não definido"}
                  </Text>
                )}
                {fields?.type === "AUDIO" ||
                fields?.type === "VIDEO" ||
                fields?.type === "IMAGE" ||
                fields?.type === "DOCUMENT" ? (
                  <Text fontSize="sm" color="gray.600">
                    <Box as="span" fontWeight="medium">
                      Arquivo:
                    </Box>{" "}
                    {fields?.filenameMidia || "Não selecionado"}
                  </Text>
                ) : null}
              </VStack>
            </Box>
          </HStack>
          <HStack align="start" spacing={3}>
            <Box bg="purple.100" p={2} rounded="md">
              <SendIcon width="20px" height="20px" color="purple.600" />
            </Box>
            <Box>
              <Text fontSize="sm" fontWeight="medium" color="primary.400">
                Configuração de Envio
              </Text>

              <VStack align="start" mt={2} spacing={1}>
                <Text fontSize="sm" color="gray.600">
                  <Box as="span" fontWeight="medium">
                    Quantidade por dia:
                  </Box>{" "}
                  {fields?.qtdEstimadaEnvioDia || "Não definido"}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  <Box as="span" fontWeight="medium">
                    WhatsApp participantes:
                  </Box>{" "}
                  {fields?.wppSessionIds?.length || 0} selecionados
                </Text>
              </VStack>
            </Box>
          </HStack>
        </VStack>
      </Box>
    </CustomModal>
  );
}

export const openModalDadosDaCampanhaWhatsApp =
  createModalTrigger<CampanhaWhatsAppCompletedDataProps>(eventName);
